import { createSagaAction } from '../../../../shared/sagas'
import { createReducer } from '../../../../shared/reducers'

// Constants
export const constants = {
  DRAWING_SCHEDULES_REPORT_GET_JOB_LIST: createSagaAction('DRAWING_SCHEDULES_REPORT_GET_JOB_LIST'),
  DRAWING_SCHEDULES_REPORT_GET_FULL_REPORT: createSagaAction(
    'DRAWING_SCHEDULES_REPORT_GET_FULL_REPORT'
  )
}

// Action Creators
export const actions = {
  drawingSchedulesReportGetJobList: ({ filters }) => ({
    type: constants.DRAWING_SCHEDULES_REPORT_GET_JOB_LIST.ACTION,
    filters
  }),
  drawingSchedulesReportGetFullReport: ({ filters }) => ({
    type: constants.DRAWING_SCHEDULES_REPORT_GET_FULL_REPORT.ACTION,
    filters
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.DRAWING_SCHEDULES_REPORT_GET_JOB_LIST.ACTION:
      return { ...state, error: null, loadingJobList: true }
    case constants.DRAWING_SCHEDULES_REPORT_GET_JOB_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingJobList: false,
        jobList: action.payload
      }

    case constants.DRAWING_SCHEDULES_REPORT_GET_FULL_REPORT.ACTION:
      return { ...state, error: null, loadingFullReport: true }
    case constants.DRAWING_SCHEDULES_REPORT_GET_FULL_REPORT.SUCCESS:
      return {
        ...state,
        error: null,
        loadingFullReport: false,
        fullReport: action.payload
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/reports/jobs/drawingSchedulesReportActions.js